import { DEFAULT_QUERY, EMPTY_SUMMARY } from './panel_transactions.constants';
import { PanelTransactionsState } from './panel_transactions.types';

export const initialPanelTransactions: PanelTransactionsState = {
    ...DEFAULT_QUERY,
    items: [],
    total: 0,
    summary: EMPTY_SUMMARY,
    historyAvailableFrom: null,
    loading: false,
    error: null,
    loadedForKey: null,
};
